import { all, take, fork, put, takeEvery } from 'redux-saga/effects';
import { toSuccess, toError } from 'react-async-client';
import { path } from 'ramda';

import { POST_LOGIN, LOGOUT, GET_USER } from 'constants/actionTypes';
import { handleTokenChange } from 'utils/token';
import { getUser } from 'actions/asyncActions';

function* loginFlow() {
    while (true) {
        yield take([toSuccess(POST_LOGIN)]);
        yield fork(put, getUser());

        yield take([LOGOUT, toError(GET_USER)]);
        yield put(getUser.reset());
        handleTokenChange(null);
    }
}

export default function* login() {
    yield all([
        loginFlow(),
        takeEvery([toSuccess(POST_LOGIN)], function ({ payload }) {
            handleTokenChange(path(['token', 'sign'], payload));
        })
    ]);
}


// WEBPACK FOOTER //
// ./src/sagas/login.js